/**
* @render react
* @name Loading
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * Loading component
 *
 * @param {Object} props - the props object
 * @param {string} props.animation - Default is pulse. If we need other animations, add refer to: https://github.com/nzbin/three-dots
 * @param {boolean} props.loadStyles - Whether to apply the class names for styling.
 * @param {Object} props.extraClassNames - Extra class names to be applied to the component
 * @param {Object} props.context - Extra information coming from Polaris provider.
 */
const Loading = (
  {
    animation,
    loadingText,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => (
  <div
    className={classNames({
      [`${cssPrefix}__loading`]: loadStyles,
      ...extraClassNames,
    })}
  >
    <div className={`${cssPrefix}__dot-${animation}`} />
    {loadingText && <div className={`${cssPrefix}__loading-text`}>{loadingText}</div>}
  </div>
);

/**
 * Valid props
 */
Loading.propTypes = {
  animation: PropTypes.string,
  loadingText: PropTypes.string,
  loadStyles: PropTypes.bool,
  context: PropTypes.shape(),
  extraClassNames: PropTypes.shape(),
};

/**
 * Default props
 */
Loading.defaultProps = {
  animation: 'pulse',
  loadingText: '',
  loadStyles: true,
  context: {},
  extraClassNames: {},
};

export default withPolaris(Loading);
